<div class="download-stage" #stage>
    <div class="mock-head">
      <div class="mock-title">Step 1: Download the file <a #downloadLink class="mock-link" href="assets/AllCards.xlsx" download>here</a>.</div>
      <div class="mock-sub">This will download the spreadsheet you need to fill in.</div>
    </div>

    <!-- Fake browser download bar -->
    <div class="download-bar" [class.visible]="step !== 'idle'">
      <div class="bar-left">
        <span class="dl-dot" aria-hidden="true"></span>
        <span class="dl-label">Downloads</span>
      </div>

      <div class="bar-right">
        <div class="dl-item" [class.downloading]="step === 'downloading'" [class.ready]="step === 'downloadReady' || step === 'clickedFile'">
          <div class="dl-file">
            <span class="file-icon" aria-hidden="true"></span>
            <span class="file-name">{{ fileName }}</span>
          </div>

          <div class="dl-meta" *ngIf="step === 'downloading'">
            <div class="progress-track">
              <div class="progress-fill" [style.width.%]="progress"></div>
            </div>
            <span class="pct">{{ progress }}%</span>
          </div>

          <button
            *ngIf="step === 'downloadReady' || step === 'clickedFile'"
            #downloadItem
            class="open-btn"
            [class.clicked]="step === 'clickedFile'"
            type="button"
          >
            Open
          </button>
        </div>
      </div>
    </div>

  <!-- Cursor overlay -->
  <div
    class="cursor"
    [class.down]="cursorDown"
    [style.transform]="'translate(' + cursorX + 'px,' + cursorY + 'px)'"
    aria-hidden="true"
  ></div>
</div>
